if (!customElements.get('table-new-tabs')) {
  class TableNewTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.panels = null;
      this._initialized = false;
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      this.tabs = this.querySelectorAll('.table-new__tab');
      if (!this.tabs.length) return;

      this.panels = this.querySelectorAll('.table-new__panel');

      const tables = this.querySelectorAll('.table-new__panel .table-new__table');
      if (tables.length >= 2) {
        const [sourceTable, targetTable] = tables;

        const sourceHead = sourceTable.querySelector('thead');
        const targetHead = targetTable.querySelector('thead');
        if (sourceHead && !targetHead) {
          targetTable.insertBefore(sourceHead.cloneNode(true), targetTable.firstChild);
        }

        const sourceBody = sourceTable.querySelector('tbody');
        const targetBody = targetTable.querySelector('tbody');
        if (sourceBody && targetBody && !targetBody.children.length) {
          const rows = Array.from(sourceBody.querySelectorAll('.table-new__row'));
          rows.forEach((row) => {
            const group = row.getAttribute('data-table-group') || 'table_1';

            if (group === 'table_2') {
              targetBody.appendChild(row);
            } else if (group === 'both') {
              const clone = row.cloneNode(true);
              targetBody.appendChild(clone);
            }
          });
        }
      }

      let defaultTab = parseInt(this.getAttribute('data-default-tab') || '1', 10);
      if (defaultTab !== 1 && defaultTab !== 2) {
        defaultTab = 1;
      }

      const tabs = this.tabs;
      const panels = this.panels;

      const showTab = (tabIndex) => {
        tabs.forEach((tab, index) => {
          const isActive = index === tabIndex;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          tab.classList.toggle('table-new__tab--active', isActive);
        });

        panels.forEach((panel, index) => {
          const isActive = index === tabIndex;
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          const table = panel.querySelector('.table-new__table');
          if (!table) return;

          const rows = table.querySelectorAll('.table-new__row');
          rows.forEach((row) => {
            const group = row.getAttribute('data-table-group') || 'table_1';
            const shouldShow =
              (tabIndex === 0 && (group === 'table_1' || group === 'both')) ||
              (tabIndex === 1 && (group === 'table_2' || group === 'both'));

            row.hidden = !shouldShow;
          });
        });
      };

      const focusTab = (newIndex) => {
        if (newIndex < 0 || newIndex >= tabs.length) return;
        tabs[newIndex].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          showTab(index);
        });

        tab.addEventListener('keydown', (event) => {
          const key = event.key;
          if (key === 'ArrowRight' || key === 'Right') {
            event.preventDefault();
            focusTab((index + 1) % tabs.length);
          } else if (key === 'ArrowLeft' || key === 'Left') {
            event.preventDefault();
            focusTab((index - 1 + tabs.length) % tabs.length);
          } else if (key === 'Home') {
            event.preventDefault();
            focusTab(0);
          } else if (key === 'End') {
            event.preventDefault();
            focusTab(tabs.length - 1);
          } else if (key === 'Enter' || key === ' ') {
            event.preventDefault();
            showTab(index);
          }
        });
      });

      const initialIndex = defaultTab === 2 ? 1 : 0;
      showTab(initialIndex);
    }
  }

  customElements.define('table-new-tabs', TableNewTabs);
}
